import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import * as routes from '../../routes/deliveries.routes'
import { formatJsDateToLocale } from '../../../util/date.service'

const AgendamentosEntregaHttp = {
  async getAgendamentosEntrega(delivery_id) {
    try {
      const result = await authHttp().get(routes.urlGetAgendamentosEntrega(delivery_id))
      return result.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async save(data) {
    try {
      data.date = formatJsDateToLocale(data.date)
        .toISO({
          suppressMilliseconds: true,
        })
        .replace('-03:00', '')

      let response
      if (data.id) response = await authHttp().put(routes.urlPostPutAgendamentoEntrega(), data)
      else response = await authHttp().post(routes.urlPostPutAgendamentoEntrega(), data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default AgendamentosEntregaHttp
